// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A5bkk","footer":"styles_footer__CcZxQ","passCodeTooltip":"styles_passCodeTooltip__ytI44"};